<template>
    <IconLink v-if="type === 'url'" />
    <svg
        v-else-if="type === 'rubric'"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
        ></path>
    </svg>
    <IconClipboardList v-else-if="type === 'quiz'" />
</template>

<script>
export default {
    name: 'StationIcon',
};
</script>

<script setup>
import { IconLink } from '@tabler/icons-vue';
import { IconClipboardList } from '@tabler/icons-vue';
defineProps({
    type: {
        type: String,
        required: true,
    },
});
</script>
